import { BridgeProvider } from "@amzn/geo-studio-web-sdk";
import { MbmProvider } from "@amzn/react-arb-tools";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import arbManifest from "translations/arbManifest";
import { getMbmOptions } from "../helpers";
import "../routeRegistryConfig";
import { ROUTES_REGISTRY } from "../routeRegistryConfig";

const mbmOptions = getMbmOptions(arbManifest);

const App = () => {
  return (
    <BridgeProvider>
      <MbmProvider {...mbmOptions}>
        <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
          <BrowserRouter>
            <Routes>
              {ROUTES_REGISTRY.map(({ path, component: Component }) => (
                <Route key={path} path={path} element={<Component />} />
              ))}
            </Routes>
          </BrowserRouter>
        </div>
      </MbmProvider>
    </BridgeProvider>
  );
};

export default App;
